import React from "react";
import {Route, Routes} from "react-router-dom";
import Rlogin from "./login/Rlogin";
import Verify from "./login/Verify";
import ManageHome from "./ManageHome"
import Ehraz from "./dashboard/Ehraz";
import EhrazWaiting from "./dashboard/EhrazWaiting";
import ManageEhraz from "./dashboard/ManageEhraz";
import {CartEhraz} from "./dashboard/CartEhraz";
import PeymentComplete from "./dashboard/PeymentComplete"
import {ListVariz} from "./dashboard/ListVariz";
import {ListBardasht} from "./dashboard/ListBardasht";
import Coins from "./Coins";
import Fund from "./dashboard/Fund";
import HistBardashtCoins from "./dashboard/HistBardashtCoins";
import HistVarizCoinsList from "./dashboard/HistVarizCoinsList"
import TopAuthentication from "./dashboard/TopAuthentication"
import {DirOrder} from "./dashboard/DirOrder";
import Account from "./dashboard/Account"
import LearnAuth from "./LearnAuth"
import BuySellLearn from "./BuySellLearn";
import CampainManager from "./camp/CampainManager";
import CampainLoading from "./camp/CampainLoading";
import { Jashnvareh } from "./camp/Jashnvareh";
import GiftPage from "./GiftPage";
import About from "./About";
import Confirmation from "./Confirmation";

import Oauth from "./dashboard/Oauth";
import Leverage from "./Leverage";
import Ai from "./Ai";
import Games from "./Games";
import Hamster from "./Hamster";

import Meme from "./Meme";
import FastAuthentication from "./dashboard/FastAuthentication";
import Webcam from "react-webcam";
import WebcamRecorder from "./dashboard/WebcamRecorder ";
const MainPages =()=>(

    <div>
       <Routes>
            <Route exact path="/" element={<ManageHome/>}/>
            <Route exact path="/login" element={<Rlogin/>}/>
            <Route path={'/verify'} element={<Verify/>}/>
            <Route path={'/ehraz'} element={<ManageEhraz/>} />
            <Route path={'/ehrazwaiting'} element={<EhrazWaiting/>} />
            <Route path={'/ehrazz'} element={<Ehraz/>} />
            <Route path={'/ehzcart'} element={<CartEhraz/>} />
            <Route path={'/callback'} element={<PeymentComplete/>} />
            <Route path={'/ListVariz'} element={<ListVariz/>} />
            <Route path={'/ListBardasht'} element={<ListBardasht/>} />
            <Route path={'/Fund'} element={<Fund/>}/>
            <Route path={'/HistBardashtCoins'} element={<HistBardashtCoins/>}/>
            <Route path={'/HistVarizCoins'} element={<HistVarizCoinsList/>}/>
            <Route path={'/OrderDetail'} element={<DirOrder/>}/>
            <Route path={'/Account'} element={<Account/>}/>
            <Route path={'/learnAuth'} element={<LearnAuth/>}/>
            <Route path={'/buysell'} element={<BuySellLearn/>}/>
            <Route path={'/prize-exchange'} element={<GiftPage/>}/>
            <Route path={'/about'} element={<About/>}/>
            <Route path={'/securityup'} element={<Oauth/>}/>
            <Route path={'/leverage-crypto-currencies-exchange'} element={<Leverage/>}/>
            <Route path={'/all-ai-crypto-currencies-list'} element={<Ai/>}/>
            <Route path={'/game-crypto-currencies-all-list'} element={<Games/>}/>
            <Route path={'/meme-coins-exchange-and-list'} element={<Meme/>}/>
            <Route path={'/fast-authentication'} element={<FastAuthentication/>}/>
            <Route path={'/top-authentication'} element={<TopAuthentication/>}/>
            <Route path={'/webcam'} element={<WebcamRecorder/>}/>
            <Route path={'/hamster-kombat-exchange'} element={<Hamster/>}/>







            <Route path={'/confirmation'} element={<Confirmation/>}/>


            <Route path={'/:title'} element={<Coins/>}/>





            










            </Routes>
    </div>
)


export default MainPages;
